import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '@/utils/lib/cn';

type TooltipProviderProps = React.ComponentProps<
  typeof TooltipPrimitive.Provider
>;
type TooltipRootProps = React.ComponentProps<typeof TooltipPrimitive.Root>;

const Tooltip = ({
  children,
  providerOptions,
  rootOptions,
}: React.PropsWithChildren & {
  providerOptions?: Omit<TooltipProviderProps, 'children'>;
  rootOptions?: TooltipRootProps;
}) => (
  <TooltipPrimitive.Provider {...providerOptions}>
    <TooltipPrimitive.Root {...rootOptions}>{children}</TooltipPrimitive.Root>
  </TooltipPrimitive.Provider>
);

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipPortal = TooltipPrimitive.Portal;

const TooltipArrow = TooltipPrimitive.Arrow;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    className={cn('tooltip', className)}
    {...props}
  />
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipPortal, TooltipTrigger, TooltipContent, TooltipArrow };
